module.exports = __webpack_public_path__ + "static/media/artglass-logo.71b20951.svg";